import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';

const DEVICE_KEY = `ELEKTRAFI_DEVICE_ID`;

const cookies = new Cookies();

const maxAge = 60 * 60 * 24 * 365; // 1 year

const cookiesService = {
  getOrCreateDeviceId: () => {
    const deviceId = cookies.get(DEVICE_KEY);
    if (!deviceId) {
      const newDeviceId = uuidv4();
      cookies.set(DEVICE_KEY, newDeviceId, {
        path: `/`,
        secure: true,
        sameSite: `strict`,
        maxAge,
      });
      return newDeviceId;
    }
    return deviceId;
  },
};

export default cookiesService;
